/* eslint-disable import/prefer-default-export */

import axios from './axios';

export const getProjectPhases = ({ params } = {}) => axios.get(`project_phases`, { params });